import React, { memo } from 'react';

import './style.scss';
import { Field, FieldProps } from 'formik';

import AutoComplete, { IAutoComplete } from '../auto-complete';

export interface IFAutoComplete extends IAutoComplete {
	name: string;
}

const FAutoComplete: React.FC<IFAutoComplete> = ({ name, ...rest }) => {
	return (
		<Field name={name}>
			{({
				field, // { name, value, onChange, onBlur }
				form: { setFieldValue, setFieldTouched }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
				meta,
			}: FieldProps) => {
				const _onChange = (value: string) => {
					setFieldValue(name, value);
				};
				return <AutoComplete {...field} {...rest} onChange={_onChange} />;
			}}
		</Field>
	);
};

export default memo(FAutoComplete);
